import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Button from "../../../Component/Button";
import { useForm } from "react-hook-form";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as userActions from "../../../actions/userActions";
import { Container, Row, Col, Form, FormControl } from "react-bootstrap";
import * as settingActions from "../../../actions/settingActions";
import { renderGlobalModal } from "../../../utils/helpers";
import PropTypes from "prop-types";

const Index = (props) => {

  const { title, superUserParams, isFrogot, actions, isSubmitting, setting } = props;
  const history = useNavigate();
  const { register, handleSubmit, formState: { errors } } = useForm({ defaultValues: superUserParams });

  const siteName = setting?.name?.trim() || "Reset your Password";

  useEffect(() => {
    const title = `${siteName} - Reset your Password`;

    document.title = title;

    document.querySelector('meta[name="description"]').setAttribute('content', "Trouble Logging In or Forgot your Password? Enter your email registered with vLookUp.ai and we'll send you a link to get back into your account.");
    if (isFrogot && !isSubmitting) {
      history({
        pathname: "/reset-password",
      });
    }

    window.scrollTo(0, 0);
  }, [siteName, title, isFrogot, history, isSubmitting]);

  useEffect(() => {
    const fetchData = async () => {
      const result = await actions.getSettingData();
      // Only show popup if you want the user to know something changed
      return result;
    };

    fetchData();
  }, [actions]);

  const onSubmit = async (data) => {
    data.request_type = "Website";
    const result = await actions.forgotPassword(data);
    renderGlobalModal({ message: result.message });
  };

  return (
    <section className="loginouter">
      <Container>
        <Row className="align-items-center ">
          <Col md={12}>
            <div className="logininnerouter">
              <div>
                <div className="loginlogo text-center mb-5">
                  <Link to="/" className="logo m-0">

                    {setting?.logo_path && <img src={setting?.logo_path} alt="logo" />}
                  </Link>
                </div>
                <div className="loginform forgotPassword">
                  <h1>Forgot Password</h1>
                  <Form onSubmit={handleSubmit(onSubmit)}>
                    <Row>
                      <Col md={12} sm={12}>
                        <Form.Group controlId="formBasicEmail">
                          <FormControl
                            type="email"
                            placeholder="Email Address"
                            className={errors?.email ? "formError" : ""}
                            name="email"
                            aria-invalid={errors?.email ? "true" : "false"}
                            {...register("email", {
                              required: true,
                              pattern: {
                                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                              },
                              maxLength: 50
                            })}
                          />
                          {errors?.email &&
                            errors?.email?.type === "required" && (
                              <span role="alert">
                                Please enter your email address
                              </span>
                            )}
                          {errors?.email &&
                            errors?.email?.type === "pattern" && (
                              <span role="alert">Invalid email address</span>
                            )}
                          {errors?.email &&
                            errors?.email?.type === "maxLength" && (
                              <span role="alert">
                                Your email should contain max 50 characters
                              </span>
                            )}
                        </Form.Group>
                      </Col>

                      <Col md={12}>
                        <div className="form-group mt-3">
                          <Button
                            title={"Submit"}
                            className={"btn w-100 loginsubmit"}
                          />
                        </div>
                      </Col>
                      <Col md={12} className="text-center mt-3">
                        <Form.Group>
                          Already have an account?&nbsp;
                          <Link to="/login" className="text-danger">
                            Login
                          </Link>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Form>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

Index.propTypes = {
  superUserParams: PropTypes.object.isRequired,
  isFrogot: PropTypes.bool.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  setting: PropTypes.shape({
    name: PropTypes.string,
    logo_path: PropTypes.string,
  }).isRequired,
  title: PropTypes.string.isRequired,
  actions: PropTypes.shape({
    forgotPassword: PropTypes.func.isRequired,
    getSettingData: PropTypes.func.isRequired,
  }).isRequired,
};

function mapStateToProps(state) {
  return {
    superUserParams: state.superUserParams,
    isFrogot: state.isFrogot,
    isSubmitting: state.isSubmitting,
    setting: state.setting,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({
      ...userActions,
      ...settingActions
    },
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Index);
